import React from 'react';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle, FiTruck, FiMapPin, FiPackage } = FiIcons;

const FLOW = {
  assigned: {
    label: 'Accept Job',
    next: 'driver_accepted',
    icon: FiCheckCircle,
    style: 'bg-blue-600 hover:bg-blue-700',
    description: 'Tap to accept this pickup job',
  },
  driver_accepted: {
    label: 'Start / On The Way',
    next: 'driver_on_the_way',
    icon: FiTruck,
    style: 'bg-orange-500 hover:bg-orange-600',
    description: 'Tap when you start heading to the customer',
  },
  driver_on_the_way: {
    label: 'Reached Pickup',
    next: 'driver_reached_pickup',
    icon: FiMapPin,
    style: 'bg-purple-600 hover:bg-purple-700',
    description: "Tap when you've arrived at the location",
  },
  driver_reached_pickup: {
    label: 'Collect Clothes',
    next: 'pickup_started',
    icon: FiPackage,
    style: 'bg-teal-600 hover:bg-teal-700',
    description: 'Tap to start collecting items from customer',
  },
};

export default function StatusButton({ status, loading, onUpdate }) {
  const config = FLOW[status];
  if (!config) return null;

  const Icon = config.icon;

  return (
    <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 p-3">
      <p className="text-xs text-gray-400 text-center mb-2">{config.description}</p>
      <button
        onClick={() => !loading && onUpdate(config.next)}
        disabled={loading}
        className={`w-full flex items-center justify-center gap-3 py-4 rounded-xl text-white font-bold text-base transition-all active:scale-95 disabled:opacity-60 disabled:cursor-not-allowed shadow-md ${config.style}`}
      >
        {loading ? (
          <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
        ) : (
          <Icon className="text-xl" />
        )}
        {loading ? 'Updating...' : config.label}
      </button>
    </div>
  );
}